import React from 'react';
import editorStyles from '../QuestionEditor/QuestionEditor.module.css';
import Input from "../../common/Input/Input";
import {useIntl} from "react-intl"; // Используем общие стили плейсхолдера

const TextSpecificEditor = () => {
    const intl = useIntl(); // <--- Получаем intl
    return (
        <div> {/* Общая обертка для отступов */}
            <Input
                disabled
                readOnly
                placeholder={intl.formatMessage({ id: "question.short_answer" })}
            />
        </div>
    );
};
export default TextSpecificEditor;
